import { PRODUCT_CLIENT } from "../constants/productClient";

export const formatter = new Intl.NumberFormat("ms", {
  style: "decimal",
  currency: "MYR",
  minimumFractionDigits: 2,
});

export const hasQueryParam = (url) => {
  return url && url.includes("?");
};

export const addQueryParam = (url, params = {}) => {
  let newRoute = url;
  if (Object.keys(params).length) {
    Object.keys(params).forEach((key) => {
      newRoute += hasQueryParam(newRoute) ? "&" : "?";
      newRoute += `${key}=${params[key]}`;
    });
  }
  return newRoute;
};

export const checkIsPayFlex = () => {
  const clientId = sessionStorage.getItem("clientId");

  return clientId == PRODUCT_CLIENT.BOOST.clientId;
};

export const isLocalhost = () => Boolean(
  window.location.hostname === "localhost"
  // [::1] is the IPv6 localhost address.
  || window.location.hostname === "[::1]"
  // 127.0.0.1/8 is considered localhost for IPv4.
  || window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
);

// https://google.com/test/?uuid=4f27ceb3-3ce2-465d-9ecb-93edc6b00a98&referenceId=jry05727-7j29-44u5-ah18-742732kt1et02&amount=1.00&currency=MYR&created=2025-04-23T09%253A21%253A02.477Z&description=&status=failed&timestamp=2025-04-23T09%253A21%253A48.039Z&signature=1j29eOQ9ei864Nt0a81WXI7L298kZ1pQQogdUxrB0yI=
export const hasBoostConnectUrlParams = (params) => (params.get("uuid") && params.get("currency") && params.get("status"));

export const isLocalDebugMode = () => isLocalhost() && window.location.href.includes("debug=1");

/**
 * Convert UPPER_SNAKE or UPPERCASE to title case with hyphens.
 * e.g. "YO" → "Yo", "YO_MA" → "Yo-Ma"
 */
export const formatLabel = (str) => {
  if (str == null || typeof str !== "string") return str;
  return str
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join("-");
};
